<template>
  <!-- 添加新用户 通用  -->
  <v-card>
    <v-card-text>
      <v-row v-if="$store.state.uuid">
        <!-- <v-col cols="12">
          <mrc_ess_switch :true-value="1"
                          :false-value="0"
                          v-if="$store.state.uuid"
                          v-model="switch1"
                          :true-text="$t('label_To_enable_the')"
                          :false-text="$t('label_disable')"></mrc_ess_switch>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            :label="$t('label_The_customer_name') + '*'"
            :isNational="judegNational('client_name')"
            :error-messages="
              $errors(
                'userdetail',
                'client_name',
                requiredRule.concat(nocharacter)
              )
            "
            v-model="userdetail.client_name"
            :readonly="readonly"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12" sm="6">
          <!-- :error-messages="$errors('userdetail','client_short_code',requiredRule.concat(nocharacter).concat([{rule:'Lettersornumbers',msg:$t('只能包含小写字母、 数字和连字符，并且必须以字母或数字开头。每个连字符前面和后面必须是非连字符字符，并且名称长度必须介于3到63个字符之间。')}]))" -->
          <mrc_ess_multiText
            :label="$t('label_Client_short_code') + '*'"
            :isNational="judegNational('client_short_code')"
            :error-messages="
              $errors(
                'userdetail',
                'client_short_code',
                requiredRule.concat(nocharacter)
              )
            "
            v-model="userdetail.client_short_code"
            :background-color="readonly ? '' : '#f2f2f2'"
            :readonly="readonly"
          >
          </mrc_ess_multiText>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6">
          <!--     :errorMessages="$errors('userdetail', 'client_tel', requiredRule)" 
          :codeErrMsg="
            $errors('userdetail', 'client_tel_area_code', requiredRule)
          " -->
          <mrc_ess_phoneInput
            :readonly="readonly"
            label=" "
            :code="userdetail.client_tel_area_code"
            :changeCode.sync="userdetail.client_tel_area_code"
            v-model="userdetail.client_tel"
          >
          </mrc_ess_phoneInput>
        </v-col>

        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            :label="$t('label_Web_site')"
            noRequired
            :isNational="judegNational('client_browser')"
            :error-messages="$errors('userdetail', 'client_browser', urlRule)"
            v-model="userdetail.client_browser"
            :readonly="readonly"
          >
          </mrc_ess_multiText>
        </v-col>
      </v-row>
      <!-- 公司商标   文件上传-->
      <v-row v-if="$store.state.uuid">
        <v-col cols="12" sm="6">
          <mrc_ess_brandupload
            v-model="userdetail.light_mode_icon"
            :disabled="readonly"
            @deleteicon="deleteicon"
            @changeimgSrc="changeimgSrc"
          ></mrc_ess_brandupload>
        </v-col>
        <v-col cols="12" sm="6">
          <mrc_ess_brandupload
            v-model="userdetail.dark_mode_icon"
            :disabled="readonly"
            @deleteicon="deleteicon"
            @changeimgSrc="changeimgSrc2"
          ></mrc_ess_brandupload>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" sm="6">
          <!--  :isNational="judegNational('client_remark')"
                             :error-messages="
            $errors('userdetail', 'data_sync_key', nocharacter)
          " -->
          <mrc_ess_multiText
            :label="$t('label_client_m_dataSynchronization')"
            noRequired
            :backgroundColor="readonly ? '#fff' : '#f5f5f5'"
            v-model="userdetail.data_sync_key"
            readonly
          >
          </mrc_ess_multiText>
        </v-col>
        <v-col cols="6" v-if="!readonly" sm="6" class="d-flex align-center">
          <v-btn
            depressed
            rounded
            class="mr-4"
            @click="refreshClick"
            color="primary"
          >
            {{ $t("label_client_m_refresh") }}
          </v-btn>
          <v-btn depressed rounded @click="emptyClick" color="primary">
            {{ $t("label_client_m_empty") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <mrc_ess_multiText
            :label="$t('label_note')"
            noRequired
            :isNational="judegNational('client_remark')"
            :error-messages="
              $errors('userdetail', 'client_remark', nocharacter)
            "
            v-model="userdetail.client_remark"
            :readonly="readonly"
          ></mrc_ess_multiText>
        </v-col>
      </v-row>
      <!-- 地址 -->
      <div class="text--secondary text-h5 d-flex align-center">
        {{ $t("label_address") }}
      </div>
      <v-card class="mt-4" flat outlined rounded="lg">
        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12">
              <mrc_ess_multiText
                :label="$t('label_The_street_address')"
                noRequired
                :error-messages="
                  $errors('userdetail', 'client_address_line_one', nocharacter)
                "
                v-model="userdetail.client_address_line_one"
                :isNational="judegNational('client_address_line_one')"
                :readonly="readonly"
              ></mrc_ess_multiText>
              <mrc_ess_multiText
                v-model="userdetail.client_address_line_two"
                noRequired
                :error-messages="
                  $errors('userdetail', 'client_address_line_two', nocharacter)
                "
                :isNational="judegNational('client_address_line_two')"
                :readonly="readonly"
              ></mrc_ess_multiText>
              <mrc_ess_multiText
                v-model="userdetail.client_address_line_three"
                noRequired
                :error-messages="
                  $errors(
                    'userdetail',
                    'client_address_line_three',
                    nocharacter
                  )
                "
                :isNational="judegNational('client_address_line_three')"
                :readonly="readonly"
              ></mrc_ess_multiText>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <mrc_ess_prompt
                :label="$t('label_city')"
                :rules="false"
                :chips="false"
                :obj="provinceName"
                v-model="userdetail.client_address_province_id"
                :disabled="readonly"
              >
              </mrc_ess_prompt>
            </v-col>
            <v-col cols="12" sm="6">
              <!--  :errMsg="
              $errors('userdetail', 'client_address_country_id', requiredRule)
            " -->
              <mrc_ess_prompt
                :label="$t('label_countries')"
                :rules="false"
                @getData="getData"
                :chips="false"
                obj="mrbase_common_geo_country"
                v-model="userdetail.client_address_country_id"
                :disabled="readonly"
              >
              </mrc_ess_prompt>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <mrc_ess_multiText
                :label="$t('label_Zip_code')"
                :error-messages="
                  $errors('userdetail', 'client_address_zip_code', nocharacter)
                "
                :isNational="judegNational('client_address_zip_code')"
                v-model="userdetail.client_address_zip_code"
                :readonly="readonly"
              ></mrc_ess_multiText>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row>
        <v-divider class="mx-3 mt-8 mb-6"></v-divider>
      </v-row>
      <!-- 联系人 -->
      <div class="text--secondary text-h5 d-flex align-center">
        {{ $t("label_The_contact") }}
      </div>
      <v-card outlined class="mt-4 tableBoxComponent" flat rounded="lg">
        <v-data-table
          hide-default-footer
          :headers="headers"
          :items="desserts"
          :items-per-page="5"
          sort-by="calories"
        >
          <template v-slot:no-data>
            <mrc_ess_noContent :no_data_text="$t('label_blank')" />
          </template>
          <template v-slot:item.contact_first_name="{ item }">
            {{ INT(item.contact_first_name) }}
          </template>

          <template v-slot:item.client_contact_status="{ item }">
            <mrc_ess_viewbtn
              :is_used="item.client_contact_status"
            ></mrc_ess_viewbtn>
          </template>

          <!-- 按钮 -->
          <template v-slot:item.actions="{ item }">
            <v-btn icon class="mr-2">
              <v-icon class="material-icons" @click="editItem(item)">
                {{ readonly ? "visibility" : "mdi-pencil" }}
              </v-icon>
            </v-btn>
            <v-btn icon v-if="!readonly">
              <v-icon class="material-icons" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:footer v-if="!readonly">
            <v-divider></v-divider>
            <mrc_ess_textAddBtn
              @click="editItem"
              :rounded="false"
              depressed
              :text="$t('label_Add_contacts')"
            >
            </mrc_ess_textAddBtn>
            <!-- <span class="mt-2 pb-2 d-flex ml-5"
                    @click="editItem">

                <span :style="{
                color: $vuetify.theme.defaults.light.primary,
                lineHeight: '28px',
                fontSize: '14px',
              }">
                  {{ $t('label_Add_contacts') }}
                </span>
                <v-icon class="material-icons"
                        :style="{
                color: $vuetify.theme.defaults.light.primary,
                fontSize: '21px',
              }">
                  add
                </v-icon>
              </span> -->
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <slot name="submitBtn"> </slot>
    <!--联系人弹出框  -->
    <mrc_ess_myDialog
      v-model="dialog"
      :title="$t('label_The_contact')"
      width="700"
      @success="save"
      @cancel="close"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" v-if="$store.state.uuid">
            <mrc_ess_switch
              true-value="1"
              v-if="$store.state.uuid"
              false-value="0"
              :readonly="readonly"
              v-model="editedItem.client_contact_status"
              :true-text="$t('label_normal')"
              :false-text="$t('label_time_out')"
            ></mrc_ess_switch>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_familyName') + '*'"
              :isNational="
                judegNational('contact_last_name', 'national_fields1')
              "
              :error-messages="
                $errors(
                  'editedItem',
                  'contact_last_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="editedItem.contact_last_name"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_GivenName') + '*'"
              :isNational="
                judegNational('contact_first_name', 'national_fields1')
              "
              :error-messages="
                $errors(
                  'editedItem',
                  'contact_first_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="editedItem.contact_first_name"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
          <!-- <v-col cols="12"
                   sm="6">
            <mrc_ess_multiText :label="$t('label_ChristianName')+'*'"
                               :isNational="judegNational('contact_middle_name','national_fields1')"
                               :error-messages="$errors('editedItem','contact_middle_name',requiredRule.concat(nocharacter))"
                               v-model="editedItem.contact_middle_name"
                               :readonly='readonly'></mrc_ess_multiText>
          </v-col> -->
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_DisplayName') + '*'"
              :isNational="
                judegNational('contact_preferred_name', 'national_fields1')
              "
              :error-messages="
                $errors(
                  'editedItem',
                  'contact_preferred_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="editedItem.contact_preferred_name"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_position_office') + '*'"
              :isNational="
                judegNational('contact_job_position', 'national_fields1')
              "
              :error-messages="
                $errors(
                  'editedItem',
                  'contact_job_position',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="editedItem.contact_job_position"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_phoneInput
              :readonly="readonly"
              :codeErrMsg="
                $errors(
                  'editedItem',
                  'client_contact_phone_area_code',
                  requiredRule
                )
              "
              :error-messages="
                $errors(
                  'editedItem',
                  'client_contact_phone_number',
                  requiredRule
                )
              "
              :code="editedItem.client_contact_phone_area_code"
              :changeCode.sync="editedItem.client_contact_phone_area_code"
              v-model="editedItem.client_contact_phone_number"
            >
            </mrc_ess_phoneInput>
          </v-col>
          <v-col cols="12">
            <mrc_ess_phoneInput
              :readonly="readonly"
              :codeErrMsg="
                $errors(
                  'editedItem',
                  'client_contact_company_area_code',
                  requiredRule
                )
              "
              :error-messages="
                $errors(
                  'editedItem',
                  'client_contact_company_phone',
                  requiredRule
                )
              "
              :code="editedItem.client_contact_company_area_code"
              :changeCode.sync="editedItem.client_contact_company_area_code"
              v-model="editedItem.client_contact_company_phone"
            ></mrc_ess_phoneInput>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_email') + '*'"
              :isNational="judegNational('client_contact_email')"
              :error-messages="
                $errors('editedItem', 'client_contact_email', [
                  ...requiredRule,
                  ...emailRule,
                ])
              "
              v-model="editedItem.client_contact_email"
              :readonly="readonly"
            ></mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>
  </v-card>
</template>

<script>
import axios from "axios";
import { getclientdetail } from "@/service/api/clientmanage_api.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  props: {
    list: {
      type: Object,
      default: () => {
        return {};
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      csfile: null,
      isShow: true,
      deleteFileList: [], //要删除的文件
      dark_mode_icon_file: "",
      light_mode_icon_file: "",
      dialog: false,
      detailData: {},
      switch1: 1,
      desserts: [],
      deletedesserts: [], //删除有uuid的列表联系人
      userdetail: {
        //客户详情
        data_sync_key: "",
        client_name: "",
        client_short_code: "",
        client_tel_area_code: "", //电话区号
        client_tel: "",
        client_browser: "",
        client_remark: "", //客户描述
        client_address_line_one: "",
        client_address_line_two: "",
        client_address_line_three: "",
        client_address_city_id: "", //城市
        client_address_province_id: "", //省份
        client_address_country_id: "", //国家
        client_address_zip_code: "", //邮编区号
        client_industry: "2", //客户所属行业
        light_mode_icon: "", //文件上传
        dark_mode_icon: "", //文件上传
        mrbase_sys_function_permission: "", //客户功能角色权限子表
        mrbase_sys_client_contacts: "", //客户联系人信息表
        mrbase_sys_client_email_whitelist: "", //客户邮箱白名单子表
        mrbase_sys_client_language: "", //客户语言子表      }
      },
      editedItem: {
        client_contact_phone_number: "",
        contact_middle_name: "",
        client_contact_email: "",
        contact_job_position: "",
        client_contact_phone_area_code: "",
        contact_preferred_name: "",
        "~table~": "mrbase_sys_client_contacts",
        client_contact_company_phone: "",
        client_contact_company_area_code: "",
        contact_last_name: "",
        contact_first_name: "",
        client_contact_status: "1",
      },
      editedIndex: -1,
      defaultItem: {
        client_contact_phone_number: "",
        contact_middle_name: "",
        client_contact_email: "",
        contact_job_position: "",
        client_contact_phone_area_code: "",
        contact_preferred_name: "",
        client_contact_company_phone: "",
        client_contact_company_area_code: "",
        contact_last_name: "",
        contact_first_name: "",
        client_contact_status: "1",
      },
    };
  },
  async mounted() {
    await this.national("mrbase_sys_clients");
    await this.national("mrbase_sys_client_contacts", "national_fields1");
    if (this.$route.params.uuid || this.$store.state.detailuuid) {
      this.userdetail = this.list;
      this.desserts = this.list.mrbase_sys_client_contacts
        ? this.list.mrbase_sys_client_contacts
        : [];
    } else {
    }
  },
  watch: {
    list: {
      handler(val) {
        this.userdetail = val;
        this.desserts = val.mrbase_sys_client_contacts
          ? val.mrbase_sys_client_contacts
          : [];
      },
      deep: true,
    },
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    refreshClick() {
      //刷新点击
      function randomRange(min = 20, max = 20) {
        var returnStr = "",
          range;
        range =
          max && typeof max == "number"
            ? Math.round(Math.random() * (max - min)) + min
            : min;
        var charStr =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < range; i++) {
          var index = Math.round(Math.random() * (charStr.length - 1));
          returnStr += charStr.substring(index, index + 1);
        }
        return returnStr;
      }
      this.userdetail.data_sync_key = randomRange();
      // console.log(this.userdetail.data_sync_key);
    },
    emptyClick() {
      //刷新点击
      this.userdetail.data_sync_key = "";
    },
    getData(v) {
      this.$set(this.userdetail, "client_address_province_id", "");
    },
    deleteicon(v) {
      if (v.uuid) {
        this.deleteFileList.push(v);
      }
      // if (v.path.indexOf('blob:') == -1) this.deleteFileList.push(v.path)
    },
    changeimgSrc2(v) {
      //将file对象存储待用
      this.csfile = v;
      this.dark_mode_icon_file = v;
      // console.log(this.dark_mode_icon_file);
    },
    changeimgSrc(v) {
      //将file对象存储待用
      this.csfile = v;
      this.light_mode_icon_file = v;
      // console.log(this.light_mode_icon_file);
    },
    moyi() {
      this.$uploadFiles(this.csfile, this.options);
    },
    getclientcontactss(val) {
      //联系人添加获取值
      if (this.desserts.length > 0) {
        this.desserts = [];
        this.desserts.push(val);
      } else {
        this.desserts.push(val);
      }
    },
    editItem(item) {
      if (item.uuid || item.client_uuid || item.client_contact_status) {
        //传了item就是修改  没传就是添加
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
      }
      this.dialog = true;
    },
    deleteItem(item) {
      //写在这里
      const index = this.desserts.indexOf(item);
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then(() => {
        const dd = this.desserts.splice(index, 1);
        // console.log(dd);
        if (dd[0].uuid || dd[0].client_uuid) this.deletedesserts.push(dd[0]);
      });
      // confirm('确认要删除吗') &&
    },
    close() {
      this.$v.editedItem.$reset();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.$v.editedItem.$touch();
      if (this.$v.editedItem.$error) return;
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    formverify() {
      //表单验证
      this.$v.userdetail.$touch();
      if (!this.$v.userdetail.$error) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    deletedessertslist() {
      //删除的联系人列表处理
      if (this.deletedesserts.length > 0) {
        return this.deletedesserts.map((item) => {
          return { ...item, "~type~": "del" };
        });
      } else {
        return [];
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    provinceName() {
      //省份查询
      return {
        prompt_name: "mrbase_common_geo_province",
        country: this.userdetail.client_address_country_id,
      };
    },
    cityName() {
      //城市查询
      return {
        prompt_name: "mrbase_common_geo_city",
        province: String(this.userdetail.client_address_province_id),
      };
    },
    options() {
      let options = {};
      // options.client_short_code = this.userdetail.client_short_code
      options.modules_uuid = 'client';
      options.function_uuid = this.$store.state.menuFunctionUuid;
      options.attachment_data_table = "mrbase_sys_clients";
      options.attachment_data_field = "light_mode_icon";
      options.org_level_uuid = this.$store.state.currentCompany;
      options.uuid = this.$store.state.detailuuid;
      return options;
    },
    headers() {
      return [
        {
          text: this.$t("label_Add_contacts"),
          align: "start",
          sortable: false,
          value: "contact_first_name",
        },
        {
          text: this.$t("label_The_phone"),
          value: "client_contact_phone_number",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_email"),
          value: "client_contact_email",
          sortable: false,
          align: "start",
        },

        {
          text: this.$t("label_state"),
          value: "client_contact_status",
          sortable: false,
          align: "start",
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
  },
  validations: {
    userdetail: {
      client_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_short_code: {
        required,
        // Lettersornumbers (val) {
        //   return /^([a-z0-9])((-)?([a-z0-9])+)*$/.test(val) && String(val).length >= 3
        // },
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_tel_area_code: {
        //电话区号
        // required,
      },
      client_tel: {
        // required,
        // areaRequired (value) {
        //   if (value) {
        //     return this.userdetail.client_tel_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   // console.log(this.userdetail.client_tel_area_code + value);
        //   // console.log(regex);
        //   return regex.test(this.userdetail.client_tel_area_code + value)
        // }
      },
      client_browser: {
        url,
      },
      client_remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      }, //客户描述
      client_address_line_one: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_address_line_two: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_address_line_three: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_address_city_id: {
        //城市
      },
      client_address_province_id: {
        //省份
      },
      client_address_country_id: {
        //国家
        // required,
      },
      client_address_zip_code: {
        //邮编区号
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_industry: {
        //客户所属行业
      },
      light_mode_icon: {
        //文件上传
      },
      dark_mode_icon: {
        //文件上传
      },
    },
    editedItem: {
      contact_last_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      contact_first_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      // contact_middle_name: {
      //   required
      // },
      contact_preferred_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      contact_job_position: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      client_contact_phone_area_code: {
        required,
      },
      client_contact_phone_number: {
        required,
        // required, areaRequired (value) {
        //   if (value) {
        //     return this.editedItem.client_contact_phone_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   return regex.test(this.editedItem.client_contact_phone_area_code + value)
        // }
      },
      client_contact_company_area_code: {
        required,
      },
      client_contact_company_phone: {
        required,
        // required, areaRequired (value) {
        //   if (value) {
        //     return this.editedItem.client_contact_company_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   return regex.test(this.editedItem.client_contact_company_area_code + value)
        // }
      },
      client_contact_email: {
        required,
        email,
      },
    },
  },
};
</script>

<style scoped>
.add_func_btn .add_btn {
  transform: rotateZ(45deg);
  font-size: 17px;
}
.adduser {
  width: 100%;
  padding: 32px 32px;
  box-shadow: none;
}
h2 {
  color: rgba(0, 0, 0, 0.38);
  text-align: left;
  height: 80px;
  line-height: 80px;
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
}
.address {
  border: 1px solid #e0e0e0;
}

.linkman td {
  text-align: center;
}
.addlinkman {
  color: orange;
}
.tableBoxComponent
  /deep/
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  padding: 8px 16px;
}
/* .statusspan {
  color: #fff;
  background-color: #18a874;
  width: 40px;
  height: 25px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 12px;
  display: inline-block;
  line-height: 25px;
  text-align: center;
}
.statusspan1 {
  color: #fff;
  background-color: red;
  width: 40px;
  height: 25px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 12px;
  display: inline-block;
  line-height: 25px;
  text-align: center;
} */
</style>
